import { BLOCKED } from "@/lib/blocked/blocked-constants";
import { TERMINAL } from "@/lib/terminal/terminal-constants";

// Undefined is a deployment too old to report the status on an events page.
export function isFollowStopStatus(status: string | undefined): boolean {
  return status !== undefined && (TERMINAL.has(status) || BLOCKED.has(status));
}
